import { Pipe, PipeTransform } from '@angular/core';
import { FlatterFilesResponse } from 'src/app/models';

@Pipe({
  name: 'toValidFlatterFilesKeys'
})
export class ToValidFlatterFilesKeysPipe implements PipeTransform {

  transform(values: { [key: string]: FlatterFilesResponse },): string[] {
    const res = [];
    for (const key in values) {
      if (Object.prototype.hasOwnProperty.call(values, key)) {
        const element = values[key];
        if(!element.error) res.push(key);
      }
    }

    return res;
  }

}
